import { Link } from 'react-router-dom';
import { ResourceItem } from '@/components/ui/ResourceItem';
import morningCenteringPhoto from '@/assets/morning-centering.jpg';
import classroomManagementPhoto from '@/assets/classroom-management.jpg';

const favoriteResources = [
  {
    type: 'audio' as const,
    title: 'Morning Centering Practice',
    description: 'Start your day with mindful breathing and centering techniques',
    duration: '4 min',
    addedDate: '1 Week Ago',
    isFavorited: true,
    photo: morningCenteringPhoto
  },
  {
    type: 'pdf' as const,
    title: 'Classroom Management Framework',
    description: 'Comprehensive guide to effective classroom management strategies and techniques',
    pages: 20,
    addedDate: '2 days ago',
    isFavorited: true,
    photo: classroomManagementPhoto
  }
];

export const ResourcesFavoritesPage = () => (
  <div className="space-y-8 animate-fade-in">
    <div className="flex justify-between items-start">
      <h1 className="text-3xl font-semibold text-white font-literata mb-2">Favorite Resources</h1>
      <div className="flex space-x-6">
        <Link to="/resources" className="text-white/70 hover:text-white transition-colors border-b-2 border-transparent hover:border-bodhi-orange pb-1">All</Link>
        <Link to="/resources/pdf" className="text-white/70 hover:text-white transition-colors border-b-2 border-transparent hover:border-bodhi-orange pb-1">PDF</Link>
        <Link to="/resources/audio" className="text-white/70 hover:text-white transition-colors border-b-2 border-transparent hover:border-bodhi-orange pb-1">Audio</Link>
        <Link to="/resources/favorites" className="text-white border-b-2 border-bodhi-orange pb-1">Favorites</Link>
      </div>
    </div>
    <div className="overflow-x-auto pb-4">
      <div className="flex space-x-4 animate-fade-in">
        {favoriteResources.map((resource, index) => (
          <ResourceItem
            key={index}
            type={resource.type}
            title={resource.title}
            description={resource.description}
            duration={resource.duration}
            pages={resource.pages}
            addedDate={resource.addedDate}
            isFavorited={resource.isFavorited}
            photo={resource.photo}
          />
        ))}
      </div>
    </div>
  </div>
);